import { URL_LABEL } from "../../../index.content";

const affiliateProgram = ({ language, isSavedUser }) => ({
  title: "Affiliate Program",
  target: false,
  ref: false,
  isLink: false,
  url: `${language === "cn" ? "https://learn.amzscout.net/affiliate-program-cn/" : "/affiliate-program/"}?${URL_LABEL}`,
});

export default affiliateProgram;
